import {invalidateQueries, q} from "../../state";
import {
  CreateTprmReportTemplate,
  ReportPromptDefinition,
  TprmReportTemplate,
  TprmReportTemplateId,
  TprmReportTemplateType,
} from "platformed-client/types";
import {platformedClient} from "..";

export async function list(): Promise<TprmReportTemplate[]> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/report_templates", {});
}

export async function promptRegistry(): Promise<Partial<Record<TprmReportTemplateType, ReportPromptDefinition[]>>> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/report_template_prompt_registry", {});
}

export async function create(reportTemplate: CreateTprmReportTemplate): Promise<TprmReportTemplateId> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/report_templates", {
    body: reportTemplate,
  });
  await invalidateQueries([q.tprm.reportTemplates.filter()]);
  return res;
}

export async function delete_(reportTemplateId: TprmReportTemplateId) {
  await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/report_templates/{report_template_id}", {
    path: {report_template_id: reportTemplateId},
  });
  await invalidateQueries([q.tprm.reportTemplates.filter()]);
}

export async function updatePortalEnabled(reportTemplateId: TprmReportTemplateId, portalEnabled: boolean) {
  await platformedClient.internalRequest(
    "patch",
    "/region/{region}/api/tprm/report_templates/{report_template_id}/portal_enabled",
    {path: {report_template_id: reportTemplateId}, body: portalEnabled},
  );
  await invalidateQueries([q.tprm.reportTemplates.filter()]);
}
